/**
 * Generated API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ProductState =
  'ACTIVE'
  | 'BOOKED'
  | 'CANCELED'
  | 'EDITING'
  | 'EDITING_MAIL'
  | 'EXPIRED'
  | 'IN_REVOCATION'
  | 'PROCESSED'
  | 'REACTIVATION_PENDING'
  | 'REGISTERED'
  | 'REGISTRATION_CANCELED'
  | 'REVOCATION_PENDING'
  | 'REVOKED'
  | 'REVOKED_FULL'
  | 'REVOKED_SUSPENDED'
  | 'SUSPENDED';

export const ProductState = {
  ACTIVE: 'ACTIVE' as ProductState,
  BOOKED: 'BOOKED' as ProductState,
  CANCELED: 'CANCELED' as ProductState,
  EDITING: 'EDITING' as ProductState,
  EDITINGMAIL: 'EDITING_MAIL' as ProductState,
  EXPIRED: 'EXPIRED' as ProductState,
  INREVOCATION: 'IN_REVOCATION' as ProductState,
  PROCESSED: 'PROCESSED' as ProductState,
  REACTIVATIONPENDING: 'REACTIVATION_PENDING' as ProductState,
  REGISTERED: 'REGISTERED' as ProductState,
  REGISTRATIONCANCELED: 'REGISTRATION_CANCELED' as ProductState,
  REVOCATIONPENDING: 'REVOCATION_PENDING' as ProductState,
  REVOKED: 'REVOKED' as ProductState,
  REVOKEDFULL: 'REVOKED_FULL' as ProductState,
  REVOKEDSUSPENDED: 'REVOKED_SUSPENDED' as ProductState,
  SUSPENDED: 'SUSPENDED' as ProductState
};
